import { Badge, Box, Button, Card, Center, Divider, Flex, Grid, Group, Loader, SimpleGrid, Skeleton, Stack, Text, ThemeIcon, Title } from "@mantine/core"
import { useNewRegistrationsTodayQuery, useNewRegistrationsYesterdayQuery } from "../../api/programregistration.api"
import { ProgramRegistration } from "../../models/programregistration.models"
import _ from "lodash";
import { useProgramGroupsQuery } from "../../api/program.api";
import { ProgramGroup } from "../../models/programs.models";
import { IconCircleArrowRightFilled } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { ProgramRegistrationList } from "./ProgramRegistrationList";
import { linkTitle } from "../../shared/helpers";

interface NewRegistrationsWidgetContentProps {
	registrations: ProgramRegistration[]|undefined;
	isLoading: boolean;
}
const NewRegistrationsWidgetContent = ({ registrations, isLoading }: NewRegistrationsWidgetContentProps) => {
	const { data: programGroups } = useProgramGroupsQuery();

	const getRegistrationsForProgramGroup = (programGroup: ProgramGroup) => {
		return registrations?.filter(r => r.ProgramGroupId === programGroup.Id) ?? [];
	}

	return <>
		{isLoading && <Skeleton height={25} mb={0} />}

		{!isLoading && registrations && <>
			<Group align="flex-start">
				
				<Center h="140px" w={140} visibleFrom="sm">
					<Stack align="center" gap={0}>
						<Text fw="normal" fz={80} style={{ lineHeight: '80px' }} variant="gradient" gradient={{ from: 'indigo', to: 'green' }}>{registrations.length}</Text>
						<Text fw="bold">New registrations</Text>
					</Stack>
				</Center>
				
				
					<Box style={{ width: "100%" }} hiddenFrom="sm">
						<Center>
							<Stack align="center" gap={0}>
								<Text fw="normal" fz={80} style={{ lineHeight: '70px' }} variant="gradient" gradient={{ from: 'indigo', to: 'green' }}>{registrations.length}</Text>
								<Text fw="bold">New registrations</Text>
							</Stack>
						</Center>
						<Divider w="100%" mt="sm" />
					</Box>
				
				
					<Center h={140} w={20} visibleFrom="sm">
						<Divider orientation="vertical"/>
					</Center>
				
				<Stack gap={0} style={{flexGrow: 1}} w="50%">
					{programGroups?.map((programGroup, index) => {
						return <div key={index}>
							<Button component={Link} to={`/registrations/list/${linkTitle(programGroup.Title)}`} ta="start" fullWidth variant="subtle" p={10} rightSection={<Badge style={{ alignSelf: 'center' }} ml="sm" miw="45px">{getRegistrationsForProgramGroup(programGroup).length}</Badge>} style={{ justifyContent: 'space-between' }}>
								<Text truncate inherit style={{ width: '500px'}}>{programGroup.Title}</Text>
							</Button>
							{/* <Link to="/registrations" style={{ textDecoration: 'none', color: 'unset' }}>
							<Flex direction="row" w="100%" justify="space-between" p={4} sx={{ borderRadius: 5, ":hover": { backgroundColor: "#eee", cursor: 'pointer' } }}>

								<Text truncate size="sm">{programGroup.Title}</Text>
								<Badge sx={{ alignSelf: 'center' }} ml="sm" miw="45px" variant="gradient">{getRegistrationsForProgramGroup(programGroup).length}</Badge>
							</Flex>
							</Link> */}
							
							{index < programGroups.length - 1 && <Divider mt={1} mb={1} w="100%" />}
						</div>
					})}
					<Divider mt={1} mb={5} w="100%" />
					{/* <Group align="flex-end" w="100%" position="right">
						<Link to="/registrations" style={{ textDecoration: 'none' }}>
							<Text variant="gradient" size="sm" weight="bold" sx={{ float: 'left', marginTop: '2px' }}>See all registrations</Text>
							<ThemeIcon variant="gradient" radius="xl" ml="xs"><IconCircleArrowRightFilled size={16} /></ThemeIcon>
						</Link>
					</Group> */}
					<Button component={Link} to="/registrations" variant="subtle" size="compact-sm" w={172} style={{ alignSelf: 'flex-end' }} p={0} rightSection={<IconCircleArrowRightFilled size={16} color="" />}>See all registrations</Button>
				</Stack>
			</Group>
		</>}
	</>
}

export const NewRegistrationsTodayDashboard = () => {
	const { data: registrations, isLoading } = useNewRegistrationsTodayQuery();

	return <>
		<Card shadow="lg" withBorder style={{ height: '100%' }}>
			<Group justify="space-between">
				<Group gap="xs">
					{/* <IconAdjustmentsHorizontal /> */}
					<Title order={3} mb={0}>Today</Title>
				</Group>
				{/* <Button variant="light" mt={-15}><IconPencil /> Edit</Button> */}
				{isLoading && <Loader size="sm" />}
			</Group>
			<NewRegistrationsWidgetContent registrations={registrations} isLoading={isLoading} />
			
		</Card>
	</>
}

export const NewRegistrationsYesterdayDashboard = () => {
	const { data: registrations, isLoading } = useNewRegistrationsYesterdayQuery();

	return <>
		<Card shadow="lg" withBorder style={{ height: '100%' }}>
			<Group justify="space-between">
				<Group gap="xs">
					{/* <IconAdjustmentsHorizontal /> */}
					<Title order={3}>Yesterday</Title>
				</Group>
				{/* <Button variant="light" mt={-15}><IconPencil /> Edit</Button> */}
				{isLoading && <Loader size="sm" />}
			</Group>
			
			<NewRegistrationsWidgetContent registrations={registrations} isLoading={isLoading} />
		</Card>
	</>
}

export const UpcomingSessionsDashboard = () => {
	// const { data: registrations, isLoading } = useNewRegistrationsYesterdayQuery();

	return <>
		<Card shadow="lg" withBorder style={{ height: '100%' }}>
			<Group justify="space-between">
				<Group gap="xs">
					<Title order={3}>Upcoming Sessions</Title>
				</Group>
				{/* {isLoading && <Loader size="sm" />} */}
			</Group>
			
			{/* <WidgetContent registrations={registrations} isLoading={isLoading} /> */}
		</Card>
	</>
}

export const RegistrationsListTodayDashboard = () => {
	const { data: registrations, isLoading } = useNewRegistrationsTodayQuery();

	return <>
		<Card shadow="lg" withBorder style={{ height: '100%' }}>
			<Group justify="space-between" mb="md">
				<Group gap="xs">
					<Title order={3}>Today's New Registrations</Title>
				</Group>
				{isLoading && <Loader size="sm" />}
			</Group>
			
			{/* <WidgetContent registrations={registrations} isLoading={isLoading} /> */}
			<ProgramRegistrationList registrations={registrations ?? []} isLoading={isLoading} showFilter={false} />
		</Card>
	</>
}